import { useEffect, useState, useRef } from "react";
import { db } from "../services/firebase";
import { collection, getDocs } from "firebase/firestore";
import { Link, useNavigate } from "react-router-dom";
import { Search } from "@mui/icons-material";

const SearchProductsMobile = () => {
  const [products, setProducts] = useState([]); // All products from Firestore
  const [filteredProducts, setFilteredProducts] = useState([]); // Filtered search results
  const [searchQuery, setSearchQuery] = useState("");
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [highlightIndex, setHighlightIndex] = useState(-1);

  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  // Fetch products from Firestore
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "products"));
        const productList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setProducts(productList);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };
    fetchProducts();
  }, []);

  // Handle search filtering
  const handleSearch = (query) => {
    setSearchQuery(query);
    if (!query.trim()) {
      setFilteredProducts([]);
      setIsDropdownVisible(false);
      return;
    }

    const lowerQuery = query.toLowerCase();
    const filtered = products.filter((product) =>
      [
        product.name,
        product.category,
        product.subcategory,
        product.brand,
        product.department,
      ].some((field) => field?.toLowerCase().includes(lowerQuery)),
    );

    setFilteredProducts(filtered);
    setIsDropdownVisible(filtered.length > 0);
  };

  // Handle keyboard navigation in dropdown
  const handleKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      setHighlightIndex((prev) =>
        Math.min(prev + 1, filteredProducts.length - 1),
      );
    } else if (e.key === "ArrowUp") {
      setHighlightIndex((prev) => Math.max(prev - 1, 0));
    } else if (e.key === "Enter" && highlightIndex !== -1) {
      navigate(`/search?query=${filteredProducts[highlightIndex].name}`);
      setIsDropdownVisible(false);
    }
  };

  return (
    <div className="flex w-11/12 mx-auto  justify-center">
      {/* Search Input */}
      <input
        type="text"
        placeholder="Search products..."
        className="w-full p-1 text-black border text-small border-gray-300 rounded-1 focus:outline-none focus:ring-2 focus:ring-purple-500"
        value={searchQuery}
        onChange={(e) => handleSearch(e.target.value)}
        onKeyDown={handleKeyDown}
        onFocus={() => searchQuery && setIsDropdownVisible(true)}
      />
      <button
        // onClick={() => }
        className="p-1 bg-coffee rounded-r text-white"
      >
        <Search />
      </button>

      {/* Dropdown for Suggestions */}
      {isDropdownVisible && (
        <ul
          ref={dropdownRef}
          className="absolute z-50 w-11/12 max-h-80 mt-10 bg-white border border-gray-300 rounded-lg shadow-lg overflow-y-auto"
        >
          {filteredProducts.map((product, index) => (
            <Link
              key={product.id}
              to={`/search?query=${product.name}`}
              onClick={() => setIsDropdownVisible(false)}
            >
              <li
                className={`p-2 text-small cursor-pointer hover:bg-coffee hover:text-white 
                ${
                  highlightIndex === index
                    ? "bg-coffee text-white"
                    : "bg-white text-black"
                }`}
              >
                <p className="truncate">{product.name}</p>
                <p
                  className={`text-small capitalize     ${
                    highlightIndex === index
                      ? "bg-coffee text-white"
                      : " text-gray-300"
                  }`}
                >
                  {product.category} | {product.brand}
                </p>
              </li>
            </Link>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SearchProductsMobile;
